import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0, 0],
        rowSpan: {
          "0:1": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide02-environment-image01.svg`,
                    styles: {
                      height: "250px",
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide02-environment-image02.svg`,
                    styles: {
                      height: "455px",
                      width: "662px",
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "Another relevant aspect to consider during sound recording is the environment. This is important as neighboring surfaces will interact with the emitted sound causing additional reflections or excitations. This can be intended to provide a realistic context for evaluation. Alternatively, measurements can be made in an anechoic room to separate the device’s sound from external influences. The decision depends on the device itself and the use cases to be evaluated.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
                styles: {
                  width: "93%",
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
